// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"855":"78e5ba2d","997":"0978cbbc"}[chunkId] + ".chunk.js";
};